
import { computed } from "vue";
import { Options, Vue } from "vue-class-component";

@Options({
  props: ["class", "padding", "margin", "height", "col", "sm", "md", "lg", "xl"]
})
export default class BaseTag extends Vue {
  public class!: string;
  public padding!: string;
  public margin!: string;
  public height!: string;
  public width!: string;
  public col!: string;
  public sm!: string;
  public md!: string;
  public lg!: string;
  public xl!: string;
  public bindingClass = computed(() => this.class);
}
